angular.module('env.data.repos.localization', [])

    .service("localizationRepository", function (rest) {
        var _this = this;
        var localizationRoute = "localization";
        var languagesRoute = "languages";

        /**
         * Get languages
         * @returns {!Promise.<Object[]>} promise of available languages collection
         */
        _this.getLanguages = function () {
            return rest.map(localizationRoute).map(languagesRoute).get();
        };

        /**
         * Get translations for language and localization keys
         * @param {string} lang language code
         * @param {string[]} [keys] localization keys
         * @returns {!Promise.<Object[]>} promise of translated resources hash
         */
        _this.getTranslations = function (lang, keys) {
            return rest.map(localizationRoute).map(languagesRoute).map(lang).get({params: {keys: keys}});
        };

        /**
         * Get list of updated translated string pairs
         * @param {string} lang language code
         * @param {Date} date date of the last update
         * @returns {!Promise.<Object[]>} promise of translated resources hash
         */
        _this.getUpdatedTranslations = function (lang, date) {
            return rest.map(localizationRoute).map(languagesRoute).map(lang).get({params: {date: date}});
        };

        return _this;
    })

;